import React, { forwardRef, Fragment, useState } from 'react'
import CropperModal from '../app/Modals/CropperModal'

const InputImage = forwardRef(
  ({ width, height, onChange, cropperShape, autoCrop, onClick, ...rest }, ref) => {
    const [imageToCrop, setImageToCrop] = useState(null)
    const aspectRatio = width && height ? width / height : undefined

    return (
      <Fragment>
        <input
          {...rest}
          ref={ref}
          accept="image/*"
          type="file"
          className="absolute w-full h-full opacity-0 cursor-pointer"
          onChange={event => setImageToCrop(event.target.files[0])}
          onClick={event => {
            onClick && onClick(event)
            event.target.value = null
          }}
        />
        <CropperModal
          image={imageToCrop}
          aspectRatio={aspectRatio}
          autoCrop={autoCrop}
          onSave={dataUrl => {
            onChange(dataUrl)
            setImageToCrop(null)
          }}
          onClose={() => setImageToCrop(null)}
          cropperShape={cropperShape}
        />
      </Fragment>
    )
  }
)

InputImage.defaultProps = {
  onChange: () => {},
}

export default InputImage
